import { render, staticRenderFns } from "./PaDeptSetting.vue?vue&type=template&id=d14f1ad8"
import script from "./PaDeptSetting.vue?vue&type=script&lang=js"
export * from "./PaDeptSetting.vue?vue&type=script&lang=js"
import style0 from "./PaDeptSetting.vue?vue&type=style&index=0&id=d14f1ad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports